<template>
  <div class="user-center-index 22">
    <NewUserCenter v-if="gameIdList.includes(currentGameId)" />
    <div v-else class="user-center-wrapper">
      <div class="user-center">
        <div class="game-info">
          <div class="display-flex align-items-center">
            <img :src="gameInfo.completed_icon_address" alt="" />
            <div class="game-name">
              <span>{{ gameInfo.name }}</span>
              <!-- <div v-if="!isLogin">
              <span @click="$eventBus.$emit('showLogin')" class="btn">
                {{ $t("userCenter.clickLogin") }}
              </span>
            </div>
            <div v-else-if="!roleList.length">
              <router-link :to="{ name: 'BindRoles' }" class="btn">
                {{ $t("userCenter.bindRole") }}
              </router-link>
            </div>
            <div v-else class="role" @click="showPopup = true">
              <span>{{ currentRoleName }}</span>
              <van-icon class="icon" name="arrow-down" />
            </div> -->
            </div>
          </div>

          <div class="display-flex align-items-center">
            <router-link :to="{ name: 'SelectGame' }" v-if="from === 'wx'">
              <div class="change-btn">
                <img src="@/assets/img/toggle.png" alt="" />
                <span>{{ $t("userCenter.changeGame") }}</span>
              </div>
            </router-link>
            <!-- <div class="change-btn" style="width: 60px;" @click="handleLang">
            <img src="@/assets/img/toggle.png" alt="">
            <span>{{ $t('userCenter.changeLanguage') }}</span>
          </div> -->
          </div>
        </div>
        <div
          v-if="
            vuexInitData && vuexInitData.banners && vuexInitData.banners.length
          "
          class="banner-container"
          :style="{
            height: calcHeight,
          }"
        >
          <van-swipe
            class="my-swipe-banner"
            :autoplay="3000"
            indicator-color="white"
          >
            <van-swipe-item
              v-for="(item, index) in vuexInitData.banners"
              :key="item.id"
            >
              <div
                class="display-flex justify-content-center align-items-center"
                style="width: 100%; height: 100%"
              >
                <img
                  :src="`${item.image_url}?x-image-process=image/quality,q_80`"
                  class="banner-img"
                  alt=""
                  @click="handleItem(index, item.link_url)"
                />
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div
          v-if="calcFaqTypeList.length"
          :class="[
            'section-box',
            'section-pd',
            calcFaqTypeList.length <= 8 ? 'no-page' : 'no-pd',
          ]"
        >
          <div class="title">{{ $t("im.猜你想问") }}</div>
          <van-swipe class="my-swipe" v-if="calcFaqTypeList.length">
            <template
              v-for="(item, index) in Math.ceil(calcFaqTypeList.length / 8)"
            >
              <van-swipe-item :key="index">
                <div class="fast-entrys">
                  <div
                    class="entry"
                    @click="handleFastEntry(currentEntry(index, i))"
                    :key="i"
                    v-for="(entry, i) in calcFaqTypeList.slice(
                      index * 8,
                      (index + 1) * 8
                    )"
                  >
                    <img :src="fastImgUrl[i]" alt="" />
                    <span>{{
                      currentEntry(index, i).name.length <= 8
                        ? currentEntry(index, i).name
                        : currentEntry(index, i).name.substr(0, 8) + "..."
                    }}</span>
                  </div>
                </div>
              </van-swipe-item>
            </template>
          </van-swipe>
        </div>
        <div class="guess section-box" v-if="faqHotList.length">
          <div class="title">{{ $t("userCenter.大家都在问") }}</div>
          <div class="faq-box">
            <template v-for="item in faqHotList">
              <div
                class="question-box"
                :key="item.id"
                @click="handleItemFaq(item)"
              >
                <div class="question-title">
                  {{ item.title }}
                </div>
                <van-icon class="arrow" color="#9A9E9E" name="arrow" />
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="btn process" @click="handleClick('process')">
          <span>{{ $t("userCenter.咨询进度查询") }}</span>
        </div>
        <div class="btn im" @click="handleClick('im')">
          <span>{{ $t("userCenter.在线咨询") }}</span>
        </div>
      </div>
      <van-popup v-model="showPopup" class="role-popup">
        <div class="role-list">
          <div class="title">{{ $t("userCenter.请选择游戏角色进入") }}</div>

          <div
            @click="changeRole(item.id)"
            :class="['role', defaultRoleInfo.id === item.id ? 'active' : '']"
            v-for="item in roleList"
            :key="item.id"
          >
            {{ item.role_name }} {{ item.server_name }}
          </div>
          <div class="add-role role" @click="changeRole('add')">
            <van-icon class="icon" name="add-o" /><span>
              {{ $t("userCenter.添加角色") }}
            </span>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="showLangPicker" position="bottom">
        <van-picker
          show-toolbar
          :confirm-button-text="$t('app.确认')"
          :cancel-button-text="$t('app.取消')"
          :columns="langColumns"
          @confirm="onLangConfirm"
          @cancel="showLangPicker = false"
        >
        </van-picker>
      </van-popup>
      <qrcode v-if="showQrcode" @close="handleClose" />
    </div>
  </div>
</template>

<script>
import storage from "@/utils/storage";
import { apiKfIndex } from "@/api/Im";
import { apiTrackLog } from "@/api/common";
import { changeRole } from "@/views/mixins";
import { mapGetters, mapActions } from "vuex";
import { apiFaqTypeList, apiFaqHotList } from "@/api/faq";
import Qrcode from "@/components/Qrcode";
import NewUserCenter from "@/views/newUserCenter/layout.vue";
import dayjs from "dayjs";
import { ImagePreview } from "vant";
// import { px2rem } from "@/utils/util";
// import Cookies from "js-cookie";

export default {
  name: "UserCenter",
  components: {
    Qrcode,
    NewUserCenter,
  },
  mixins: [changeRole],
  data() {
    return {
      gameIdList: [157, 126, 2277, 2022, 14, 70, 171, 38, 25],
      gameInfo: {},
      fastEntrys: [],
      faqHotList: [],
      faqList: [],
      showPopup: false,
      showQrcode: false,
      from: "game",
      showLangPicker: false,
      langColumns: [
        { text: this.$t("app.zh"), key: "zh" },
        { text: this.$t("app.en"), key: "en" },
      ],
      faqTypeList: [],
      isLogin: false,
      fastImgUrl: [
        require("@/assets/img/fast/0.png"),
        require("@/assets/img/fast/1.png"),
        require("@/assets/img/fast/2.png"),
        require("@/assets/img/fast/3.png"),
        require("@/assets/img/fast/4.png"),
        require("@/assets/img/fast/5.png"),
        require("@/assets/img/fast/6.png"),
        require("@/assets/img/fast/7.png"),
      ],
      calcHeight: "0px",
      currentGameId: storage.getGameId(),
    };
  },
  computed: {
    ...mapGetters(["vuexInitData", "defaultRoleInfo"]),
    calcFaqTypeList() {
      // 取前面8个
      return this.faqTypeList.slice(0, 8);
    },
    currentEntry() {
      return function (index, i) {
        return (
          (this.faqTypeList[index * 8 + i] &&
            this.faqTypeList[index * 8 + i]) ||
          {}
        );
      };
    },
  },

  mounted() {
    window.staticFn.customEvent("visit_user_center_page", {
      game_id: storage.getGameId(),
    });
    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    const gameId = storage.getGameId();
    // 刺客伍六七逻辑，弹窗二维码
    // 2024年12月31日早上11点之后，就不弹窗了
    const now = dayjs().valueOf();
    const end = dayjs("2024-12-31 11:00:00").valueOf();
    if (gameId === 2293 && now < end) {
      if (window.staticFn) {
        const config = window.staticFn.getConfig();
        apiTrackLog({
          guest_id: config && config.guest_uid,
        });
      }
      const noRemind =
        localStorage.getItem("noRemind") || sessionStorage.getItem("noRemind");
      // const noRemind = Cookies.get("noRemind");
      try {
        if (noRemind) {
          const today = dayjs().format("YYYY-MM-DD");
          const remindDay = dayjs(Number(noRemind)).format("YYYY-MM-DD");
          if (today !== remindDay) {
            this.showQrcode = true;
          } else {
            this.showQrcode = false;
          }
        } else {
          this.showQrcode = true;
        }
      } catch {
        this.showQrcode = true;
      }
    }
    if (this.currentGameId === 157) {
      return;
    }
    this.getImInitData();
    let from = sessionStorage.getItem("from");
    let q_from = this.$route.query.from;
    if (q_from) {
      sessionStorage.setItem("from", q_from);
      this.from = q_from;
    } else if (from) {
      this.from = from;
    }
    // 获取热门列表
    this.getFaqHotList();
    this.getFaqTypes();
    // 监听登录成功事件
    this.listenEvent();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    this.$eventBus.$off("loginSuccess");
  },
  methods: {
    ...mapActions(["checkLogin"]),
    // 监听登录成功事件
    listenEvent() {
      this.$eventBus.$on("loginSuccess", () => {
        this.isLogin = true;
      });
    },
    handleResize() {
      const currentWidth = window.innerWidth;
      const currentHeight = Math.floor(currentWidth / 2.87);
      // console.log(currentHeight);
      // this.calcHeight = px2rem(currentHeight);
      this.calcHeight = currentHeight + "px";
    },
    handleClose() {
      this.showQrcode = false;
    },
    getFaqTypes() {
      apiFaqTypeList({
        from: sessionStorage.getItem("from") || "",
      }).then((res) => {
        if (res.code === 0) {
          this.faqTypeList = res.data || [];
        }
      });
    },
    // 获取热门问题
    getFaqHotList() {
      apiFaqHotList({
        limit: 7,
        from: sessionStorage.getItem("from") || "",
      }).then((res) => {
        if (res.code === 0) {
          this.faqHotList = res.data || [];
        }
      });
    },
    getImInitData() {
      this.showLoading();
      apiKfIndex()
        .then((res) => {
          if (res.code === 0) {
            this.faqList = res.data.faq;
            this.faqList.forEach((item) => {
              this.$set(item, "showMore", false);
            });
            this.fastEntrys = res.data.service_list || [];
            this.gameInfo = res.data.chat_game;
            sessionStorage.setItem("gameInfo", JSON.stringify(this.gameInfo));
          }
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    // 快捷跳转
    async handleFastEntry(item) {
      this.$router.push({
        name: "ImChat",
        query: { id: item.id, title: item.name },
      });
    },
    // 点击切换语言
    handleLang() {
      this.showLangPicker = true;
    },
    // 切换语言
    onLangConfirm(data) {
      this.showLangPicker = false;
      this.$i18n.locale = data.key;
      localStorage.setItem("lang", data.key);
    },
    // 常见问题
    handleItemFaq(item) {
      this.$router.push({
        name: "faqDetail",
        params: {
          id: item.id,
        },
      });
    },
    handleClick(type) {
      if (type === "im") {
        this.$router.push({ name: "ImChat" });
        // if (!this.defaultRoleInfo.id || this.defaultRoleInfo.id == "tourist") {
        //   this.showPopup = true;
        // } else {
        //   this.$router.push({ name: "ImChat" });
        // }
      } else if (type === "process") {
        this.checkLogin()
          .then(() => {
            if (
              !this.defaultRoleInfo.id ||
              this.defaultRoleInfo.id === "tourist" ||
              this.defaultRoleInfo.is_guest === 1
            ) {
              this.$router.push({
                name: "BindRoles",
              });
              return;
            }
            this.$router.push({ name: "ReportHistory" });
          })
          .catch(() => {
            this.$eventBus.$emit("showLogin");
          });
      }
    },
    changeRole(val) {
      this.handleChangeRole(val, () => {
        this.showPopup = false;
      });
    },
    handleItem(index, url) {
      if (url) {
        window.open(url, "_blank");
      }
      // if (this.from !== "wx" && url) {
      //   window.open(url, "_blank");
      //   return;
      // }
      // const data = this.vuexInitData.banners.map((item) => item.image_url);
      // ImagePreview({
      //   images: data,
      //   startPosition: index,
      //   closeable: true,
      // });
    },
  },
};
</script>

<style lang="less" scoped>
.user-center-index {
  height: 100%;
}
.user-center-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f8f8f8;
}
.user-center {
  // padding: 15px;
  // background: #fff;
  flex: 1;
  overflow: auto;
  .banner-container {
    width: 100%;
  }
  .my-swipe-banner {
    width: 100%;
    height: 100%;
    padding-bottom: 0;
    overflow: hidden;

    .banner-img {
      width: 100%;
      // height: 100%;
      object-fit: cover;
    }
  }
}
.game-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 10px;
  background-color: #fff;
  img {
    width: 40px;
    height: 40px;
  }
  .game-name {
    display: flex;
    margin-left: 8px;

    flex-direction: column;
    justify-content: center;
    color: #333;
    font-size: 16px;
    font-weight: bold;
    .btn {
      display: inline-block;
      width: 80px;
      height: 22px;
      line-height: 22px;
      color: #fff;
      font-size: 12px;
      text-align: center;
      background: #e64b5c;
      box-shadow: 0px 2px 6px 0px rgba(230, 75, 92, 0.4);
      border-radius: 11px;
    }
    .role {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #797a8c;
      background: #e5e5e5;
      border-radius: 11px;
      padding: 3px 6px;
      white-space: nowrap;
      max-width: 170px;
      overflow: hidden;
      text-overflow: ellipsis;
      .icon {
        margin-left: 6px;
      }
    }
  }
  .change-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 86px;
    padding: 0 10px;
    height: 26px;
    text-align: center;
    line-height: 26px;
    background: #fff;
    border-radius: 14px;
    font-size: 12px;
    color: @gold;
    border: 1px solid @gold;
    img {
      width: 13px;
      height: 13px;
      margin-right: 4px;
    }
  }
}
.fast-entrys {
  display: grid;
  grid-gap: 20px 10px;
  // grid-auto-flow: row dense;
  grid-template-columns: repeat(4, 1fr);
  .entry {
    display: flex;
    flex-direction: column;
    align-items: center;
    white-space: nowrap;
    span {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }
    img {
      width: 20px;
      height: 20px;
      margin-bottom: 8px;
    }
    color: #333;
    font-size: 12px;
  }
}

.tools {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px 16px;
  .tool {
    flex: 1;
    display: flex;
    align-items: center;
    img {
      width: 28px;
      height: 28px;
    }
    .tool-info {
      // height: 28px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 10px;
      & > span:first-child {
        font-size: 14px;
        color: #242424;
      }
      & > span:last-child {
        font-size: 11px;
        color: #797a8c;
      }
    }
  }
}

.question-box {
  display: flex;
  align-items: center;
  padding: 16px 0;
  box-sizing: border-box;
  font-size: 14px;
  & + .question-box {
    border-top: 1px solid rgba(0, 0, 0, 0.04);
  }
  .question-title {
    flex: 1;
    color: #333;
    font-size: 14px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.footer {
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;
  padding: 16px 10px;
  display: flex;
  box-sizing: border-box;
  background-color: #fff;
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 162px;
    height: 42px;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 16px;
  }
  .process {
    color: @gold;
    border: 1px solid @gold;
  }
  .im {
    color: #fff;
    background-color: @gold;
  }
}
.role-popup {
  border-radius: 10px;
  padding: 20px 25px;
}
.role-list {
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 15px;
    color: #242424;
    margin-bottom: 16px;
  }
  .role {
    width: 140px;
    height: 31px;
    line-height: 31px;
    text-align: center;
    border-radius: 16px;
    color: #797a8c;
    font-size: 12px;
    border: 1px solid #a2a3b2;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 10px;
    &.active {
      background: #e64b5c;
      border-color: #e64b5c;
      color: #fff;
    }
  }
  .add-role {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #242424;
    .icon {
      font-size: 16px;
      margin-right: 6px;
    }
  }
}
.section-box {
  margin-top: 8px;
  background: #ffffff;
  &.guess {
    padding: 18px 10px;
    padding-bottom: 2px;
    .title {
      margin-bottom: 18px;
      color: #333;
      font-size: 16px;
      font-weight: bold;
    }
  }
  &.section-pd {
    padding: 18px 10px;
    .title {
      margin-bottom: 18px;
      color: #333;
      font-size: 16px;
      font-weight: bold;
    }
  }
}

.no-page {
  /deep/ .van-swipe {
    padding: 0;
  }
}
.no-pd {
  padding-bottom: 0;
}
.marginT12 {
  margin-top: 12px;
}
</style>
